<template>
  <div id="app">
    <keep-alive
      :include="[
        'BindingDoctors',
        'DoctorDetail',
        'UserCenter',
        'UserInfo',
        'OrderList',
        'OrderDetail',
        'CustomerService',
        'PlaceOrder'
      ]"
      :exclude="['requestCart']"
    >
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
import store from './store';

// import { mapActions } from 'vuex';
export default {
  name: 'App',
  data() {
    return {
      // userInfo: ''
    };
  },
  created() {
    // this.getUserInfo();
    store.dispatch('getRxShadeConfig');
  },
  methods: {
    // ...mapActions(['getUserInfo'])
  }
};
</script>

<style lang="scss">
@import url(./styles/index.css);
</style>
